import { createAsyncThunk } from "@reduxjs/toolkit";
import radioService from "../../../api/services/radio";

export const getRadioTracks = createAsyncThunk("radio/get-tracks", async () => {
  return await radioService.getTracks();
});

export const createRadioTrack = createAsyncThunk(
  "radio/create-track",
  async (requestData) => {
    return await radioService.createTrack(requestData);
  },
);

export const reorderRadioTracks = createAsyncThunk(
  "radio/reorder-tracks",
  async (ids) => {
    return await radioService.reorderTracks(ids);
  },
);

export const updateRadioTrack = createAsyncThunk(
  "radio/update-track",
  async ({ id, requestData }) => {
    return await radioService.updateTrack({ id, requestData });
  },
);

export const toggleRadioTrack = createAsyncThunk(
  "radio/toggle-track",
  async (id) => {
    return await radioService.toggleTrack(id);
  },
);

export const deleteRadioTrack = createAsyncThunk(
  "radio/delete-track",
  async (id) => {
    return await radioService.deleteTrack(id);
  },
);
